const LOG_LEVELS = {
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
};

export const logger = {
  info: (message, data = {}) => {
    console.log(`[${LOG_LEVELS.INFO}] ${message}`, data);
  },
  warn: (message, data = {}) => {
    console.warn(`[${LOG_LEVELS.WARN}] ${message}`, data);
  },
  error: (message, error, data = {}) => {
    console.error(`[${LOG_LEVELS.ERROR}] ${message}`, { error, ...data });
  },
};
